import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

const getBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL
  }
  return process.env.NODE_ENV === "production"
    ? "https://server-softzenitcrmback8009-rg0nra-c9f28b-62-84-177-235.sslip.io/"
    : "http://127.0.0.1:8000/"
}

const baseQuery = fetchBaseQuery({
  baseUrl: getBaseUrl(),
  prepareHeaders: (headers, { getState }) => {
    const token = process.env.REACT_APP_TOKEN
    if (token) {
      headers.set("Authorization", `Token ${token}`)
    }
    return headers
  },
})

const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery,
  tagTypes: [
    "auth",
    "user",
    "clientLeads",
    "client",
    "project",
    "task",
    "targets",
    "attendance",
    "payroll",
    "weekend",
    "holiday",
    "device",
  ],
  endpoints: builder => ({}),
})

export default baseApi
